import React, {Component} from 'react'
import {Alert, Button, Descriptions, Input, Modal, Spin, Tag} from 'antd'
import {withTranslation} from 'react-i18next'
import userManagementAPI from '../../../apis/userManagementAPI'

class ClawBotModal extends Component {
  state = {loading: true, status: null, code: '', error: ''}

  componentDidMount() {
    this.refresh()
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
  }

  data = response => {
    if (!response || response.data.code !== 0) throw new Error(response?.data?.message || 'ClawBot request failed')
    return response.data.data || {}
  }

  schedule = status => {
    clearTimeout(this.timer)
    const phase = status.phase || status.state
    if (['WAIT', 'SCANNED', 'VERIFY_REQUIRED', 'PAIRING'].includes(phase)) {
      this.timer = setTimeout(this.refresh, 2000)
    }
  }

  refresh = async () => {
    try {
      const status = this.data(await userManagementAPI.clawBotStatus(this.props.record.id))
      this.setState({loading: false, status, error: ''})
      this.schedule(status)
    } catch (error) {
      this.setState({loading: false, error: error.message || String(error)})
    }
  }

  run = async action => {
    this.setState({loading: true, error: ''})
    try {
      const next = this.data(await action())
      const status = {...this.state.status, ...next}
      this.setState({loading: false, status})
      this.schedule(status)
    } catch (error) {
      this.setState({loading: false, error: error.message || String(error)})
    }
  }

  render() {
    const {record, t, onClose} = this.props
    const {loading, status, code, error} = this.state
    const phase = status?.phase || status?.state || 'UNBOUND'
    const pairing = ['WAIT', 'SCANNED', 'VERIFY_REQUIRED', 'PAIRING'].includes(phase)
    return (
      <Modal visible title={`${t('userManagement.clawbot')} - ${record.shortName}`} onCancel={onClose}
             footer={<Button onClick={onClose}>{t('general.close')}</Button>} destroyOnClose>
        <Spin spinning={loading}>
          {error ? <Alert type="error" showIcon message={error} style={{marginBottom: 16}}/> : null}
          <Descriptions column={1} size="small" bordered>
            <Descriptions.Item label={t('userManagement.clawbotBindStatus')}>
              <Tag color={phase === 'BOUND' ? 'green' : pairing ? 'blue' : 'default'}>
                {t(`userManagement.clawbotPhase.${phase}`, {defaultValue: phase})}
              </Tag>
            </Descriptions.Item>
            <Descriptions.Item label={t('userManagement.clawbotEnabled')}>
              {status?.enabled ? t('general.enable') : t('general.disable')}
            </Descriptions.Item>
          </Descriptions>

          {status?.qrDataUrl ? <div style={{textAlign: 'center', margin: 20}}>
            <img src={status.qrDataUrl} width="260" height="260" alt={t('userManagement.clawbotQr')}/>
            <div>{t('userManagement.clawbotQrHint')}</div>
          </div> : null}

          {phase === 'VERIFY_REQUIRED' ? <div style={{display: 'flex', marginTop: 16}}>
            <Input value={code} maxLength={8} onChange={event => this.setState({code: event.target.value})}
                   placeholder={t('userManagement.clawbotVerifyCode')}/>
            <Button type="primary" style={{marginLeft: 8}}
                    onClick={() => this.run(() => userManagementAPI.clawBotVerify(record.id, code))}>
              {t('general.ok')}
            </Button>
          </div> : null}

          {status?.message ? <Alert type="warning" showIcon message={status.message} style={{marginTop: 16}}/> : null}

          <div style={{marginTop: 20, textAlign: 'right'}}>
            {!pairing && phase !== 'BOUND' ? <Button type="primary"
              onClick={() => this.run(() => userManagementAPI.clawBotPair(record.id))}>
              {t('userManagement.clawbotBind')}
            </Button> : null}
            {phase === 'BOUND' && status?.enabled ? <Button
              onClick={() => this.run(() => userManagementAPI.clawBotDisable(record.id))}>
              {t('userManagement.clawbotDisable')}
            </Button> : null}
            {phase === 'BOUND' && !status?.enabled ? <Button type="primary"
              onClick={() => this.run(() => userManagementAPI.clawBotEnable(record.id))}>
              {t('userManagement.clawbotEnable')}
            </Button> : null}
            {(pairing || phase === 'BOUND') ? <Button danger style={{marginLeft: 8}}
              onClick={() => this.run(() => userManagementAPI.clawBotUnbind(record.id))}>
              {t('userManagement.clawbotUnbind')}
            </Button> : null}
          </div>
        </Spin>
      </Modal>
    )
  }
}

export default withTranslation()(ClawBotModal)
